/**
 * Sidebar route order matches MainLayout primary + secondary (excluding dividers).
 * Used to pick a default landing route after tenant portal login.
 */

export const SIDEBAR_ROUTE_ORDER: readonly string[] = [
    '/programs',
    '/dashboard',
    '/question-bank',
    '/documents',
    '/content-types',
    '/tags',
    '/tag-types',
    '/tenants',
    '/settings/theme',
    '/settings/system',
];

export function getFirstAccessibleRoute(
    hasScreenAccess: (path: string) => boolean,
    fallback = '/programs'
): string {
    for (const path of SIDEBAR_ROUTE_ORDER) {
        if (hasScreenAccess(path)) {
            return path;
        }
    }
    return fallback;
}
